<app-barra-consulta-export *ngIf="!carregando" visible="false" [listagemComFiltros]="getListagemComFiltros()"
    (atualizando)="atualizar($event)" (inserindo)="novo($event)" (definirFiltro)="definirFiltragem()"
    [exibirNovo]="false" [detalhe]="detalhe">
</app-barra-consulta-export>
<div class="conteudo">
    <app-loading [exibir]="carregando"></app-loading>
    <div *ngIf="!carregando">
        <div class="row mt-2">
        </div>
        <div class="row">
            <div class="col">
                <div class="fieldset mb-2">
                    <div class="ml-2">
                        <label translate class="legend">{{'estoque.relatorioKardex.defineRelatorioExportadas'}}</label>
                        <div class="mt-3 ml-3">
                            <input name="groupname" (change)="enviaValor()" value="kardex" [(ngModel)]="selectedValue" type="radio">&nbsp;
                            <label translate>{{'estoque.relatorioKardex.extracaoKardex'}}</label><br>
                            <input name="groupname" (change)="enviaValor()" value="estoque" [(ngModel)]="selectedValue" type="radio">&nbsp;
                            <label translate>{{'estoque.relatorioKardex.extracaoEstoque'}}</label><br>
                            <input name="groupname" (change)="enviaValor()" value="peca_rede" [(ngModel)]="selectedValue" type="radio">&nbsp;
                            <label translate>{{'estoque.relatorioKardex.extracaoPecaRede'}}</label><br>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div translate class="jumbotron"><i class="fas fa-info-circle fa-lg"></i>&nbsp;
            {{'estoque.relatorioKardex.exportacaoRelatoriosKardex'}}
            <p translate>{{'estoque.relatorioKardex.utilizeTelExportacaoKardex'}}</p>
            <div class="row">
                <div class="col-md">
                    <button [disabled]="botao" class="btn btn-outline-secondary btn-sm mb-2 float-left" (click)="exportarExcel()">
                        <em class="fa fa-download fa-xs"></em>
                        Export CSV
                    </button>
                </div>
            </div>
        </div>

        <div *ngIf="!carregando" >

        <div class=" table-scroll" style="display: none;">
            <div class="container-fluid content mt-4" >
               
                    <table class="table table-bordered table-striped table-hover" id="RPTKardexExcel">
                        <thead class="thead-dark">
                            <tr>
                                <th>Data</th>
                                <th>Dealer</th>
                                <th>Transacao</th>
                                <th>Part_Number</th>
                                <th>Descricao</th>
                                <th>Qtd</th>
                                <th>Qtd_final</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let dados of dadosKardex?.dados">
                                <td>{{dados?.data}}</td>
                                <td>{{dados?.codigo_dealer}}</td>
                                <td>{{dados?.transacao}}</td>
                                <td>{{dados?.part_number}}</td>
                                <td>{{dados?.descricao}}</td>
                                <td>{{dados?.quantidade}}</td>
                                <td>{{dados?.quantidade_final}}</td>
                            </tr>
                        </tbody>
                    </table>
            
                    <table class="table table-bordered table-striped table-hover" id="RPTEstoqueExcel">
                        <thead class="thead-dark">
                            <tr>
                                <th>Dealer</th>
                                <th>Part_Number</th>
                                <th>Descrição</th>
                                <th>Disponivel</th>
                                <th>Reserva_Alocacao</th>
                                <th>Curva</th>
                                <th>Custo_Contabil</th>
                                <th>Sub_Total</th>
                                <th>Categoria Item</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let dados of dadosEstoque?.dados" >
                                <td>{{dados?.codigo_dealer}}</td>
                                <td>{{dados?.part_number}}</td>
                                <td>{{dados?.descricao}}</td>
                                <td>{{dados?.disponivel}}</td>
                                <td>{{dados?.reserva}}</td>
                                <td>{{dados?.curva}}</td>
                                <td>{{dados?.custo}}</td>
                                <td>{{dados?.total}}</td>
                                <td>{{dados?.categoria_item}}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table class="table table-bordered table-striped table-hover" id="RPTPecaRedeExcel">
                        <thead class="thead-dark">
                            <tr>
                                <th>Concessionaria</th>
                                <th>Part_Number</th>
                                <th>Descricao</th>
                                <th>Disponivel</th>
                                <th>Curva</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let dados of dadosPecaRede?.dados" >
                                <td>{{dados?.codigo_dealer}}</td>
                                <td>{{dados?.part_number}}</td>
                                <td>{{dados?.descricao}}</td>
                                <td>{{dados?.disponivel}}</td>
                                <td>{{dados?.curva}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>